import "./blocks/circle-text";
import "./blocks/cookie-settings";
import "./blocks/cookie-dialog";
import "./blocks/form";
import "./blocks/hero";
import "./blocks/image-teaser";
import "./blocks/line-through-hover";
import "./blocks/navigation";
import "./blocks/page-transition";
import "./blocks/slider";
import "./blocks/top-link";
import "./lib/images";
import "./lib/typo-animation";
import { rem } from "./lib/utilities";
import { addCategory } from "./lib/cookie-consent";
import { getString } from "./lib/localization";

addCategory("md-dzwjfi", {
   label: getString("cookieConsent.category.media"),
});

addCategory("an-pgurbs", {
   label: getString("cookieConsent.category.analytics"),
});

window.addEventListener("load", () => {
   Array.from(document.querySelectorAll(".reveal")).forEach(reveal => reveal.style.height = rem(reveal.firstElementChild.offsetHeight));
});
